import SectionHub from '@/components/docs/SectionHub';

export default function Docs02AlternativeDataSentimentHub() {
  return <SectionHub sectionPath="02-alternative-data/sentiment" />;
}
